import './AboutUsContainer.css'
import useWindowDimensions from '../../../../hooks/useWindowDimensions'
import AboutUsDesktop from '../AboutUsDesktop/AboutUsDesktop'
import AboutUsMobile from '../AboutUsMobile/AboutUsMobile'
import { useAppContext } from '../../../../context/AppState/AppContext'

export default function AboutUsContainer() {
   const { jsonTexts, jsonMedia } = useAppContext();
   const {title, subtitleTag, subtitle} = jsonTexts.inicio.aboutUsContainer;
   
   const { firstImage, secondImage} = jsonMedia?.inicio?.aboutUs

   const {width} = useWindowDimensions();
   const isMobile = width <= 768;
   return (
      <section className='aboutUs-section'>
         <div className='aboutUs-first-container'>
            {
               isMobile 
                  ? < AboutUsMobile title={title} subtitleTag={subtitleTag} subtitle={subtitle} firstImage={firstImage} secondImage={secondImage} /> 
                  : < AboutUsDesktop title={title} subtitleTag={subtitleTag} subtitle={subtitle} firstImage={firstImage} secondImage={secondImage} />
            }
         </div>
      </section>
   )
}
